// Pillars constants mirrored from backend for friendly labels & icons.
import {
	Briefcase,
	ShieldCheck,
	Umbrella,
	Baby,
	Repeat,
	Sunrise,
} from 'lucide-react';

export const PILLARS = [
	{ key: 'income_stability', title: 'Income Stability', icon: Briefcase, accent: 'from-blue-500 to-blue-700', blurb: 'How resilient your household income is against disruption.' },
	{ key: 'emergency_preparedness', title: 'Emergency Preparedness', icon: ShieldCheck, accent: 'from-emerald-500 to-emerald-700', blurb: 'Cash buffers and contacts for the unexpected.' },
	{ key: 'insurance_preparedness', title: 'Insurance Preparedness', icon: Umbrella, accent: 'from-sky-500 to-sky-700', blurb: 'Health, life and term coverage for the family.' },
	{ key: 'child_preparedness', title: 'Child Preparedness', icon: Baby, accent: 'from-amber-400 to-amber-600', blurb: 'Education runway and guardianship plans.' },
	{ key: 'financial_continuity', title: 'Financial Continuity', icon: Repeat, accent: 'from-violet-500 to-fuchsia-500', blurb: 'Day-to-day finances continuing smoothly.' },
	{ key: 'future_readiness', title: 'Future Readiness', icon: Sunrise, accent: 'from-rose-400 to-orange-400', blurb: 'Retirement, long-term goals & legacy.' },
];

export function pillarTitle(key) {
	return PILLARS.find((p) => p.key === key)?.title || key;
}
